// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_RESET_CSV_DATA,
} from './constants';

export function resetCsvData() {
  return {
    type: COMMON_RESET_CSV_DATA,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_RESET_CSV_DATA:
      return {
        ...state,
        csvTableData:null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/resetCsvData.js